import React, { Dispatch, SetStateAction } from 'react';
import moment from 'moment/moment';
import { MaxHeightContainer } from '@eltoro-ui/components';
import { Layout, PageHeader, SummaryCart } from 'Components';
import { CampaignCreationWrapper } from 'Pages/CampaignCreation/components/CampaignCreationWrapper';
import GeneratedCampaignCreatives from 'Pages/CampaignCreation/components/GeneratedCampaign/GeneratedCampaignContent/GeneratedCampaignCreatives';
import { generatedCampaignCostType } from 'Pages/CampaignCreation/components/GeneratedCampaign/GeneratedCampaign';
import './GeneratedCampaign.scss';

type GeneratedCampaignCheckoutProps = {
  campaignCostAccData: generatedCampaignCostType;
  selectedItems: string[];
  setSelectedItems: Dispatch<SetStateAction<string[]>>;
  setCampaignCostAccData: Dispatch<SetStateAction<generatedCampaignCostType>>;
  onUpdateCampaign: () => Promise<void>;
};
const GeneratedCampaignCheckout = ({
  campaignCostAccData,
  selectedItems,
  setSelectedItems,
  setCampaignCostAccData,
  onUpdateCampaign,
}: GeneratedCampaignCheckoutProps) => {
  const [changedBannerFiles, setChangedBannerFiles] = React.useState<{ id: string; file: File }[]>(
    []
  );

  const days = moment(campaignCostAccData.endDate)
    .add({ days: 1 })
    .diff(moment(campaignCostAccData.startDate), 'days');

  return (
    <div className="CampaignSetup Generated-campaign">
      <MaxHeightContainer
        fullHeight
        header={
          <PageHeader
            UNSAFE_CLASSNAME_GRID="CampaignSetup__titleSpace"
            UNSAFE_CLASSNAME="CampaignSetup__header"
            UNSAFE_CLASSNAME_TITLE="CampaignCheckout__title "
            actionsStyle="CampaignSetup__progress"
            title={campaignCostAccData.campaign?.campaign.name}
          />
        }
      >
        <div className="generated-campaign-layout">
          <Layout>
            <CampaignCreationWrapper>
              <div>
                <div className="CampaignSetup__audiences">
                  {campaignCostAccData.campaign && (
                    <GeneratedCampaignCreatives
                      changedBannerFiles={changedBannerFiles}
                      setChangedBannerFiles={setChangedBannerFiles}
                      campaignData={campaignCostAccData.campaign}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
                      onUpdateCampaign={onUpdateCampaign}
                    />
                  )}
                </div>
              </div>
              {campaignCostAccData.campaign && (
                <SummaryCart
                  isCheckout
                  days={days}
                  campaignCostAccData={campaignCostAccData}
                  setCampaignCostAccData={setCampaignCostAccData}
                  isGenerationFlow
                  changedBannerFiles={changedBannerFiles}
                  selectedItems={selectedItems}
                />
              )}
            </CampaignCreationWrapper>
          </Layout>
        </div>
      </MaxHeightContainer>
    </div>
  );
};

export default GeneratedCampaignCheckout;
